/* unplugin-vue-components disabled */import { render } from "./CTypeTabs.vue?vue&type=template&id=92d6cd84&scoped=true&ts=true"
import script from "./CTypeTabs.vue?vue&type=script&lang=ts"
export * from "./CTypeTabs.vue?vue&type=script&lang=ts"

import "./CTypeTabs.vue?vue&type=style&index=0&id=92d6cd84&scoped=true&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92d6cd84"]])

export default __exports__